"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceivableRepaymentsHistorySchema = exports.NormalizedRepaymentFieldsSchema = exports.NormalizedRepaymentDerivedFieldsSchema = exports.SanitizedNormalizedRepaymentInputFieldsSchema = exports.NormalizedRepaymentInputFieldsSchema = exports.RepaymentEntryBaseFieldsSchema = void 0;
const zod_1 = require("zod");
const Bank_1 = require("./Bank");
const Utils_1 = require("./Utils");
exports.RepaymentEntryBaseFieldsSchema = zod_1.z.record(zod_1.z.string(), Utils_1.PrimitiveStruct);
// These fields need to be configured by tape-builder "Edit" operation
exports.NormalizedRepaymentInputFieldsSchema = zod_1.z.object({
    finleyRepaymentAmount: zod_1.z.number(),
    finleyRepaymentDate: Utils_1.ZodFullDateStrForJsonSchemaStruct,
    finleyCurrencyCode: Bank_1.CurrencyCodeSchema,
    finleyValidRepayment: zod_1.z.boolean(),
});
// Zod schema for SanitizedNormalizedRepaymentInputFields (snake_case keys)
exports.SanitizedNormalizedRepaymentInputFieldsSchema = zod_1.z.object({
    finley_repayment_amount: zod_1.z.number(),
    finley_repayment_date: Utils_1.ZodFullDateStrForJsonSchemaStruct,
    finley_currency_code: Bank_1.CurrencyCodeSchema,
    finley_valid_repayment: zod_1.z.boolean(),
});
// Note: Compile-time assertion is omitted because CamelKeysToSnake
// produces Currency enum type while CurrencyCodeSchema produces string union
// These fields can then be derived based on the above "input" fields
exports.NormalizedRepaymentDerivedFieldsSchema = zod_1.z.object({
    normalizedRepaymentAmount: zod_1.z.number(),
});
exports.NormalizedRepaymentFieldsSchema = exports.NormalizedRepaymentInputFieldsSchema.merge(exports.NormalizedRepaymentDerivedFieldsSchema);
// Zod schema for ReceivableRepaymentsHistory
exports.ReceivableRepaymentsHistorySchema = zod_1.z.object({
    normalizedRepaymentAmount: zod_1.z.number(),
    finleyRepaymentDate: Utils_1.ZodFullDateStrForJsonSchemaStruct,
});
//# sourceMappingURL=RepaymentEntry.js.map